module.exports = __webpack_public_path__ + "static/media/icon-tv-outline.0f1b95b8.svg";